import { call, put, takeLatest } from 'redux-saga/effects';

import { PersonalAccidentQuote } from '@models/PersonalAccidentQuote';
import { PersonalAccidentQuoteApi } from '@apis/PersonalAccidentQuoteApi';
import { history } from '@utils/history';
import { SagaPayload } from '@utils/typescript';
import { BillingApi } from '@apis/BillingApi';
import { Billing } from '@models/Billing';
import { routePersonalAccidentQuotePaymentPage } from '@components/PersonalAccidentQuotePaymentPage';

import {
  personalAccidentQuoteFind,
  PersonalAccidentQuoteFindPayload,
  personalAccidentQuoteCreate,
  PersonalAccidentQuoteCreatePayload,
  personalAccidentQuoteFetch,
  PersonalAccidentQuoteFetchPayload,
  personalAccidentQuoteUpdate,
  PersonalAccidentQuoteUpdatePayload,
  personalAccidentQuoteCustom,
  PersonalAccidentQuoteCustomPayload,
  personalAccidentQuotePay,
  PersonalAccidentQuotePayPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';
import { routePersonalAccidentQuoteBuyReviewPage } from './route';

function* handlePersonalAccidentQuoteFind({ payload }: SagaPayload<PersonalAccidentQuoteFindPayload>) {
  const state: StateUpdatePayload = { personalAccidentQuote: null };
  try {
    state.personalAccidentQuote = (yield call(PersonalAccidentQuoteApi.find, payload)) as PersonalAccidentQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handlePersonalAccidentQuoteCreate({ payload }: SagaPayload<PersonalAccidentQuoteCreatePayload>) {
  const state: StateUpdatePayload = { personalAccidentQuote: null };
  try {
    state.personalAccidentQuote = (yield call(PersonalAccidentQuoteApi.create, payload)) as PersonalAccidentQuote;
    yield put(stateUpdate(state));
    history.navigate(routePersonalAccidentQuoteBuyReviewPage({ orderNumber: state.personalAccidentQuote.orderNumber }));
  } catch { }
}

function* handlePersonalAccidentQuoteFetch({ payload }: SagaPayload<PersonalAccidentQuoteFetchPayload>) {
  const state: StateUpdatePayload = { personalAccidentQuote: null };
  try {
    state.personalAccidentQuote = (yield call(PersonalAccidentQuoteApi.get, payload)) as PersonalAccidentQuote;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handlePersonalAccidentQuoteUpdate({ payload }: SagaPayload<PersonalAccidentQuoteUpdatePayload>) {
  const state: StateUpdatePayload = { personalAccidentQuote: null };
  try {
    state.personalAccidentQuote = (yield call(PersonalAccidentQuoteApi.update, payload)) as PersonalAccidentQuote;
    yield put(stateUpdate(state));
    history.navigate(routePersonalAccidentQuoteBuyReviewPage({ orderNumber: state.personalAccidentQuote.orderNumber }));
  } catch { }
}

function* handlePersonalAccidentQuoteCustom({ payload }: SagaPayload<PersonalAccidentQuoteCustomPayload>) {
  const state: StateUpdatePayload = { personalAccidentQuote: null };
  try {
    state.personalAccidentQuote = (yield call(PersonalAccidentQuoteApi.custom, payload)) as PersonalAccidentQuote;
    yield put(stateUpdate(state));
    history.navigate(routePersonalAccidentQuoteBuyReviewPage({ orderNumber: state.personalAccidentQuote.orderNumber }));
  } catch { }
}

function* handlePersonalAccidentQuotePay({ payload }: SagaPayload<PersonalAccidentQuotePayPayload>) {
  try {
    const { id } = (yield call(BillingApi.create, payload)) as Billing;
    history.navigate(routePersonalAccidentQuotePaymentPage({ orderNumber: payload.orderNumber, billingId: id }));
  } catch { }
}

export default function* () {
  yield takeLatest(personalAccidentQuoteFind, handlePersonalAccidentQuoteFind);
  yield takeLatest(personalAccidentQuoteCreate, handlePersonalAccidentQuoteCreate);
  yield takeLatest(personalAccidentQuoteFetch, handlePersonalAccidentQuoteFetch);
  yield takeLatest(personalAccidentQuoteUpdate, handlePersonalAccidentQuoteUpdate);
  yield takeLatest(personalAccidentQuoteCustom, handlePersonalAccidentQuoteCustom);
  yield takeLatest(personalAccidentQuotePay, handlePersonalAccidentQuotePay);
}
